var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar}}):_c('app-icon',{attrs:{"icon":"avatar-placeholder","size":"full"}})
}
var staticRenderFns = []

export { render, staticRenderFns }